import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default function (param) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_SNS',
  });

  useEffect(() => {
    if (param && param.query) {
      let url = `/api/sns?category=${JSON.stringify(param.category)}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return data;
}
